import { useTranslation } from 'react-i18next';

import { Button, Flex, Typography } from 'antd';

import { CopyButton } from 'shared/ui';

import styles from './SettingsAbout.module.scss';

export const SettingsAbout = () => {
	const { t } = useTranslation();
	// TODO:
	const LINK = 'https://t.me/app/Telerev';
	return (
		<Flex vertical gap={12} className={styles.content}>
			<Flex align="center" justify="space-between" gap={16}>
				<Typography.Text>{t('Ссылка')}</Typography.Text>
				<Typography.Link>{LINK}</Typography.Link>
				<CopyButton text={LINK} />
			</Flex>

			<Flex gap={8} justify="space-between">
				{/*TODO: */}
				<Button size="large" onClick={() => console.log('Зарепортить')}>
					{t('Зарепортить')}
				</Button>
				<Button size="large" onClick={() => console.log('Предложить изменение')}>
					{t('Предложить изменение')}
				</Button>
			</Flex>
		</Flex>
	);
};
